import { render } from "./signatories.html?vue&type=template&id=36a146ae&scoped=true&ts=true&external"
import script from "./signatories.ts?vue&type=script&lang=ts&external"
export * from "./signatories.ts?vue&type=script&lang=ts&external"

import "./signatories.scss?vue&type=style&index=0&id=36a146ae&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a146ae"]])

export default __exports__